/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';

import useTopPanel from 'hooks/useTopPanel';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import ChatAddModal from './ChatAddModal';

function ChatSettings() {
  const { t, i18n } = useTranslation();
  const { setComponent } = useTopPanel();
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setComponent(
      <div className='component-title'>
        <span className='mr-4'>{t('settings.telegram.title')}</span>
        <Button
          variant='base'
          onClick={() => {
            setOpen(true);
          }}
        >
          <i className='bi bi-plus-circle-fill !text-lg' />
        </Button>
      </div>
    );
  }, [i18n.language]);

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ['/admin/telegram/chats'],
    queryFn: async function () {
      const response = await axiosPrivate.get('/admin/telegram/chats');
      return response?.data?.data;
    },
    enabled: !hasError,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  return (
    <div className='py-6 setting-wrapper h-full overflow-y-auto my-scroll'>
      {!data?.length || isLoading || isFetching ? (
        <div className='circular-progress-box h-full'>
          <CircularProgress size={35} />
        </div>
      ) : (
        <Grid
          container
          spacing={{ xs: 2, sm: 2, lg: 2 }}
          columns={{ xs: 12, sm: 12, lg: 12 }}
        >
          {data?.length
            ? data?.map((tg) => (
                <Grid key={tg?.id} item={true} lg={4} sm={6} xs={12}>
                  <Link
                    to={`/admin/settings/telegram/${tg?.id}`}
                    className='settings-item'
                  >
                    <Button
                      fullWidth
                      variant='outlined'
                      className='settings-item-btn'
                    >
                      <div>
                        <span className='ml-2'>{tg?.name}</span>
                        <br />
                        <span className='ml-2 text-base text-gray-600'>
                          ({tg?.chat_id})
                        </span>
                      </div>
                    </Button>
                  </Link>
                </Grid>
              ))
            : ''}
        </Grid>
      )}
      <ChatAddModal open={open} setOpen={setOpen} refetch={refetch} />
    </div>
  );
}

export default memo(ChatSettings);
